import View from './View';

export { default as View, getCastVolumeControllerStyles } from './View';

export default View;
